export default __webpack_public_path__ + "static/media/projet1.f590f843.png";